import { useEffect, useState } from "react";
import SortIcon from "components/icons/sort";
import TooltipButton from "components/common/Tooltip/TooltipButton";
import context from "lib/stores/context";
import { RadixTooltip } from "../Tooltip/RadixTooltip";
import * as Tooltip from "@radix-ui/react-tooltip";
import { useSnapshot } from "valtio";

const DetailsPaneTableHeader = () => {
  const { sortTableBy, sortTableOrder, activeView, activeTabWorldwide, activeTabRegions } = useSnapshot(context);
  const [hidden, setHidden] = useState(true);
  useEffect(() => {
    if (
      (activeTabWorldwide === 0 && activeView === "worldwide") ||
      (activeTabRegions === 0 && activeView === "region") ||
      (activeTabWorldwide === 1 && activeView === "worldwide")
    ) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  }, [activeTabWorldwide, activeTabRegions]);

  const onClickAsc = key => {
    context.sortTableBy = key;
    context.sortTableOrder = "asc";
  };

  const onClickDesc = key => {
    context.sortTableBy = key;
    context.sortTableOrder = "desc";
  };

  if (
    (activeView === "worldwide" && activeTabWorldwide === 0) ||
    (activeView === "worldwide" && activeTabWorldwide === 1) ||
    (activeView === "region" && activeTabRegions === 0)
  ) {
    return (
      <thead className="sticky top-[92px] left-0 right-0 w-full z-10">
        <tr
          id="details-pane-table-header"
          className={`w-full grid md:grid-cols-6 grid-cols-12 md:px-0 h-8 transition-all duration-500 ease-out ${
            hidden ? "opacity-0 -translate-x-0" : ""
          }`}
        >
          <th
            onClick={() => {
              context.sortTableBy = "country";
              if (sortTableOrder === "asc") {
                onClickDesc("country");
              } else {
                onClickAsc("country");
              }
            }}
            style={{ borderColor: "rgb(229, 231, 235)" }}
            className="border-t-[1px] border-b-[2px] cursor-pointer text-left bg-white font-bold text-[10px] pl-4 text-gray-800 md:col-span-2 col-span-4 text-left border-r-[1px] flex items-center justify-between"
          >
            <div className="flex items-center justify-center space-x-1 text-left">
              {activeView === "worldwide" && activeTabWorldwide === 1 ? (
                <span className="uppercase">Region</span>
              ) : (
                <span className="uppercase">Country</span>
              )}
              <SortIcon active={sortTableBy === "country"} />
            </div>
            <div className=" h-full bg-gray-100 w-2 md:flex opacity-0 pointer-events-none pointer-events-none hidden items-center justify-center relative">
              <RadixTooltip
                content="Estimated proportion of population living in modern slavery out of 1000"
                Trigger={TooltipButton}
                className="opacity-0"
              />
            </div>
            {/* <div */}
            {/*   className='h-full bg-gray-100 w-8 border-l-[1px] flex items-center justify-center tooltip' */}
            {/*   data-tip='Estimated proportion of population living in modern slavery out of 1000'> */}
            {/*   <TooltipButton></TooltipButton> */}
            {/* </div> */}
          </th>
          <th
            onClick={() => {
              context.sortTableBy = "focus";
              if (sortTableOrder === "asc") {
                onClickDesc("focus");
              } else {
                onClickAsc("focus");
              }
            }}
            style={{ borderColor: "rgb(229, 231, 235)" }}
            className="border-t-[1px] border-b-[2px] bg-gray-100 cursor-pointer uppercase text-[10px] text-gray-800 space-x-1 md:col-span-1 col-span-2 text-left   flex items-center justify-center"
          >
            <span className="md:block hidden">RESOURCES</span>
            <span className="md:hidden">DOCS</span>
            <SortIcon active={sortTableBy === "focus"} />
          </th>
          <th
            onClick={() => {
              context.sortTableBy = "prev";
              if (sortTableOrder === "asc") {
                onClickDesc("prev");
              } else {
                onClickAsc("prev");
              }
            }}
            style={{ borderColor: "rgb(229, 231, 235)" }}
            className="border-t-[1px] border-b-[2px] bg-gray-100 uppercase cursor-pointer font-bold text-[10px] text-gray-800 md:col-span-1 col-span-2 space-x-1 text-left  flex items-center  justify-center"
          >
            <span>PREV</span>
            <SortIcon active={sortTableBy === "prev"} />
          </th>
          <th
            onClick={() => {
              context.sortTableBy = "vuln";
              if (sortTableOrder === "asc") {
                onClickDesc("vuln");
              } else {
                onClickAsc("vuln");
              }
            }}
            style={{ borderColor: "rgb(229, 231, 235)" }}
            className="border-t-[1px] border-b-[2px] bg-gray-100 cursor-pointer uppercase font-bold text-[10px] text-gray-800 md:col-span-1 col-span-2 text-left space-x-1  flex items-center justify-center"
          >
            <span>VULN</span>
            <SortIcon active={sortTableBy === "vuln"} />
          </th>
          <th
            onClick={() => {
              context.sortTableBy = "gov resp";
              if (sortTableOrder === "asc") {
                onClickDesc("gov resp");
              } else {
                onClickAsc("gov resp");
              }
            }}
            style={{ borderColor: "rgb(229, 231, 235)" }}
            className="border-t-[1px] border-b-[2px] bg-gray-100 cursor-pointer uppercase font-bold text-[10px] text-gray-800 md:col-span-1 col-span-2 text-left space-x-1 flex items-center justify-center pr-2"
          >
            <span className="md:block hidden">GOV RESP</span>
            <span className="md:hidden">GOV</span>
            <SortIcon
              active={sortTableBy === "gov resp"}
              onClickAsc={() => onClickAsc("gov resp")}
              onClickDesc={() => onClickDesc("gov resp")}
            />
          </th>
        </tr>
      </thead>
    );
  }
};

export default DetailsPaneTableHeader;
